import DataTable from "react-data-table-component"
import FilterInTable from "../../../../../Manage/FilterInTable"
import { useEffect, useState } from "react"
import PaginationComponent from "../../../../../Manage/PaginationComponent"
import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent"

const GiftVoucher = () => {

    const [itemsPerPage, setItemsPerPage] = useState(3)
    const [currentPage, setCurrentPage] = useState(1)
    const [currentItems, setCurrentItems] = useState([])

    const data = [
        { name: 'Special Gift', code: "Voucher10", type: 'Store Credit', validityPeriod: '30 March - 7 April', value: 30, conditions: ['Min.spent: 20$', 'New customers only'], applicability: 'Electronics', redemption: 20, status: "Active" },
        { name: 'Special Gift', code: "Voucher10", type: 'Store Credit', validityPeriod: '30 March - 7 April', value: 30, conditions: ['Min.spent: 20$', 'New customers only'], applicability: 'Electronics', redemption: 20, status: "Active" },
        { name: 'Special Gift', code: "Voucher10", type: 'Store Credit', validityPeriod: '30 March - 7 April', value: 30, conditions: ['Min.spent: 20$', 'New customers only'], applicability: 'Electronics', redemption: 20, status: "Active" },
        { name: 'Special Gift', code: "Voucher10", type: 'Store Credit', validityPeriod: '30 March - 7 April', value: 30, conditions: ['Min.spent: 20$', 'New customers only'], applicability: 'Electronics', redemption: 20, status: "Active" },
    ]

    const columns = [
        {
            name: 'Voucher Name',
            selector: row => row.name,
            wrap: true
        },
        {
            name: 'Voucher Code',
            selector: row => row.code,
            wrap: true
        },
        {
            name: 'Voucher Type',
            selector: row => row.type,
            wrap: true
        },
        {
            name: 'Validity Period',
            selector: row => row.validityPeriod,
            wrap: true
        },
        {
            name: 'Value',
            cell: row => <span>${row.value}</span>,
            wrap: true
        },
        {
            name: 'Conditions',
            cell: row => <div>
                {row.conditions.map(item => <div>{item}</div>)}
            </div>,
            wrap: true
        },
        {
            name: 'Applicability',
            selector: row => row.applicability,
            wrap: true
        },
        {
            name: 'Redemption',
            selector: row => <span>{row.redemption}%</span>,
            wrap: true
        },
        {
            name: "Status",
            selector: row => row.status,
            wrap: true
        }
    ]

    const handlePageChange = (page) => {
        setCurrentPage(page)
        const startIndex = (page - 1) * itemsPerPage
        const endIndex = startIndex + itemsPerPage
        setCurrentItems(data.slice(startIndex, endIndex))
    }

    const handleRowsPerPageChange = (newItemsPerPage) => {
        setItemsPerPage(newItemsPerPage)
        setCurrentPage(1)
        handlePageChange(1)
    }

    useEffect(() => {
        handlePageChange(currentPage)
    }, [currentPage, itemsPerPage])

    return (
        <div className="bg-white p-3">
            <div className="mb-3">
                <FilterInTable componentName='Vouchers All' />
            </div>

            <DatatableComponent responsive data={currentItems} columns={columns} type="gray" />

            <PaginationComponent
                totalItems={data.length}
                siblingCount={2}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </div>
    )
}

export default GiftVoucher